export default __webpack_public_path__ + "assets/team.8df97bc9.png";